<template>
  <v-data-table :no-data-text="RuText.NO_DATA" class="table" v-bind="$attrs">
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-data-table>
</template>

<script>
import { RuText } from '@/constants';

export default {
  name: 'Table',
  data: () => ({
    RuText,
  }),
};
</script>

<style lang="scss">
.table {
  th {
    font-size: 14px !important;
    font-weight: 600;
    color: #080707 !important;

    span {
      font-size: inherit;
    }
  }

  td {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
}
</style>
